import { c as _c } from "react/compiler-runtime";
import { useStore } from 'zustand';
import { useMemo } from 'react';
import { useShallow } from 'zustand/shallow';
import { useMeasuresStore, type MeasuresStore } from '../store/use-measure-store';
import { useKeyboard } from './use-keyboard';
export interface MeasuredKeyCount {
  measured: number;
  total: number;
}

/**
 * How far the first pass of measurements has got: a key counts once it has
 * both a down weight and an up weight, the pair every later figure is built
 * from.
 *
 * Reads the raw store rather than the analysed keyboard: this sits in the
 * sidebar, so it runs on every page and on every keystroke of the measure
 * table.
 */
export const useMeasuredKeyCount = () => {
  const $ = _c(6);
  const {
    keyboard
  } = useKeyboard();
  const keys = useStore(useMeasuresStore(), useShallow(_temp));
  let t0;
  if ($[0] !== keyboard.size || $[1] !== keys) {
    t0 = keys.slice(0, keyboard.size).filter(_temp2);
    $[0] = keyboard.size;
    $[1] = keys;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== keyboard.size || $[4] !== t0.length) {
    t1 = {
      measured: t0.length,
      total: keyboard.size
    };
    $[3] = keyboard.size;
    $[4] = t0.length;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};
function _temp(state) {
  return state.keys;
}
function _temp2(key) {
  return key.downWeightWithoutSpringSupport !== null && key.upWeight !== null;
}